
import {map, flatMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseService, AppSettingsService, AuthenticationService, ServiceManager } from 'iui-iconectiv-lib';
import { GenericResponse } from '../shared';

const GET_MY_ACCOUNT = '/api/account/myaccount';

@Injectable()
export class SummaryService extends BaseService {

    public finderAccountKey = 'finderAccountKey';

    constructor(
        serviceManager: ServiceManager,
        private http: HttpClient,
        private appSettings: AppSettingsService,
        private authService: AuthenticationService,
    ) {

        super(serviceManager);

    }

    /**
     * Retrieve the account data
     */
    getMyAccount(): Observable<any> { 
        // console.log("get my account in summary service");
        return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
            const url = this.getServer(settings) + GET_MY_ACCOUNT;
            return this.http.get(url, {
                headers: new HttpHeaders()
                    .append('Content-Type', 'application/json')
                    .append('Authorization', this.authService.getToken())
                    .append('Cache-control', 'no-cache')
                    .append('Cache-control', 'no-store')
                    .append('Expires', '0')
                    .append('Pragma', 'no-cache'),
                responseType: 'text'
            }).pipe(map(res => { 
                // console.log(res);
                const r = this.parseToType<GenericResponse>(res);
                return r;
            }));
        })));
    }

        /**
     * Retrieve the account data
     */
    getMyAccountWithoutEmit(): Observable<any> { 
        return this.appSettings.getSettings().pipe(flatMap(settings => {
            const url = this.getServer(settings) + GET_MY_ACCOUNT;
            return this.http.get(url, {
                headers: new HttpHeaders()
                    .append('Content-Type', 'application/json')
                    .append('Authorization', this.authService.getToken())
                    .append('Cache-control', 'no-cache')
                    .append('Cache-control', 'no-store')
                    .append('Expires', '0')
                    .append('Pragma', 'no-cache'),
                responseType: 'text'
            }).pipe(map(res => { 
                const r = this.parseToType<GenericResponse>(res);
                return r;
            }));
        }));
    }

    

    /**
     * retrieve the account associated with this user.
     */
    getFinderAccount(): any {
        return JSON.parse(sessionStorage.getItem(this.finderAccountKey + '-' + this.authService.username()));
    }

    /**
     * Update the account associated with this user.
     */
    setFinderAccount(a: any) {
        sessionStorage.setItem(this.finderAccountKey + '-' + this.authService.username(), JSON.stringify(a));
    }


}
